:host{display:flex;gap:4px}.btn-material{display:inline-flex}.btn-material mat-icon{font-size:20px;height:auto;width:auto}.without-checked-state.mat-button-toggle-checked{background-color:#fff}
/*# sourceMappingURL=view-settings-3d.component.css.map */
